export enum LoadStatusEnum {
  NotLoaded = 0,
  Loaded = 1,
  Loading = 2,
  Error = 3,
  offline = 4
}
